import { api } from "../../lib/api";
import type { ProductVisualKey } from "@ventas/shared";

export type Category = {
  id: number;
  name: string;
  iconKey: ProductVisualKey;
  active: boolean;
  _count: { products: number };
};

export const categoriesApi = {
  list: (params: { active?: boolean; search?: string } = {}) => {
    const query = new URLSearchParams();
    if (params.active !== undefined) query.set("active", String(params.active));
    if (params.search) query.set("search", params.search);
    const suffix = query.toString();
    return api<Category[]>(`/api/categories${suffix ? `?${suffix}` : ""}`);
  },
  create: (body: { name: string; iconKey?: ProductVisualKey }) => api<Category>("/api/categories", { body }),
  update: (id: number, body: Partial<{ name: string; iconKey: ProductVisualKey; active: boolean }>) =>
    api<Category>(`/api/categories/${id}`, { method: "PATCH", body }),
};
